import { Box, TextField } from '@mui/material';

export interface ResidentTableHeaderTextInputProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  autoFocus?: boolean; //if true, field will be focused automatically
}
const ResidentsTableHeaderTextInput = (props: ResidentTableHeaderTextInputProps) => {
  return (
    <Box>
      <TextField
        value={props.value}
        onChange={props.onChange}
        autoFocus={props.autoFocus}
        fullWidth
        variant="outlined"
        InputProps={{
          sx: {
            height: '40px', // Set the height of the input field
          },
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '25px', // Rounded corners
          },
        }}
      />
    </Box>
  );
};

export default ResidentsTableHeaderTextInput;
